export interface MockPayment {
  id: string;
  productId: string;
  productName: string;
  productSlug: string;
  provider: 'yookassa' | 'allpay';
  providerPaymentId: string;
  status: 'succeeded' | 'pending' | 'failed' | 'canceled';
  amount: number;
  currency: 'RUB' | 'ILS';
  customerName: string;
  customerEmail: string;
  customerPhone: string;
  failReason: string | null;
  createdAt: string;
}

export interface MockAudit {
  id: string;
  userId: string;
  userEmail: string;
  action: string;
  entity: string;
  entityId: string | null;
  createdAt: string;
}

const now = Date.now();
const ago = (mins: number): string => new Date(now - mins * 60 * 1000).toISOString();

const firstNames = ['Алексей', 'Мария', 'Дмитрий', 'Ольга', 'Сергей', 'Анна', 'Ирина', 'Михаил', 'Екатерина', 'Yael', 'David', 'Noa'];
const lastNames = ['Иванов', 'Петрова', 'Смирнов', 'Козлова', 'Lerner', 'Goldberg', 'Katz', 'Mizrahi', 'Романова'];
const domains = ['gmail.com', 'yandex.ru', 'mail.ru', 'walla.co.il', 'outlook.com'];
const statuses: MockPayment['status'][] = ['succeeded', 'succeeded', 'succeeded', 'succeeded', 'succeeded', 'pending', 'failed', 'canceled'];
const products = [
  { id: 'p_01', slug: 'webinar-crypto-2026', name: 'Вебинар «Криптоактивы в 2026»', priceRub: 890000, priceIls: 38000 },
  { id: 'p_02', slug: 'consult-1h', name: 'Консультация 60 минут', priceRub: 1500000, priceIls: 65000 },
  { id: 'p_03', slug: 'masterclass-tax-il', name: 'Мастер-класс по налогам', priceRub: 450000, priceIls: 19000 },
  { id: 'p_04', slug: 'pdf-guide-relocation', name: 'PDF-гид: Релокация', priceRub: 190000, priceIls: 8000 },
  { id: 'p_05', slug: 'course-investment-basics', name: 'Курс «Основы инвестиций»', priceRub: 2400000, priceIls: 99000 },
];

function rng(seed: number): () => number {
  let s = seed;
  return (): number => {
    s = (s * 9301 + 49297) % 233280;
    return s / 233280;
  };
}

const rand = rng(42);
const payments: MockPayment[] = [];
let pid = 1000;
for (const prod of products) {
  for (let i = 0; i < 22; i++) {
    const status = statuses[Math.floor(rand() * statuses.length)] as MockPayment['status'];
    const currency: 'RUB' | 'ILS' = rand() > 0.45 ? 'ILS' : 'RUB';
    const amount = currency === 'RUB' ? prod.priceRub : prod.priceIls;
    const fn = firstNames[Math.floor(rand() * firstNames.length)];
    const ln = lastNames[Math.floor(rand() * lastNames.length)];
    const email =
      (fn + '.' + ln).toLowerCase().replace(/[^a-z.]/g, '') +
      '@' +
      domains[Math.floor(rand() * domains.length)];
    payments.push({
      id: 'pay_' + (pid++).toString(36),
      productId: prod.id,
      productName: prod.name,
      productSlug: prod.slug,
      provider: currency === 'RUB' ? 'yookassa' : 'allpay',
      providerPaymentId: currency === 'RUB' ? '2f3a9b' + pid : 'AP-' + pid,
      status,
      amount,
      currency,
      customerName: fn + ' ' + ln,
      customerEmail: email,
      customerPhone:
        '+' +
        (currency === 'RUB' ? '7' : '972') +
        Math.floor(rand() * 900000000 + 100000000).toString(),
      failReason: status === 'failed' ? 'insufficient_funds' : null,
      createdAt: ago(Math.floor(rand() * 60 * 24 * 30)),
    });
  }
}
payments.sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1));

export const MOCK = {
  payments,
  products,
  audit: [
    { id: 'a1', userId: 'u_01', userEmail: 'pavel@payments.local', action: 'product.created', entity: 'product', entityId: 'p_05', createdAt: ago(60 * 24 * 3) },
    { id: 'a2', userId: 'u_02', userEmail: 'anna.m@payments.local', action: 'product.updated', entity: 'product', entityId: 'p_03', createdAt: ago(60 * 4) },
    { id: 'a3', userId: 'u_01', userEmail: 'pavel@payments.local', action: 'user.created', entity: 'user', entityId: 'u_03', createdAt: ago(60 * 24 * 14) },
    { id: 'a4', userId: 'u_01', userEmail: 'pavel@payments.local', action: 'product.deactivated', entity: 'product', entityId: 'p_04', createdAt: ago(60 * 24 * 30) },
    { id: 'a5', userId: 'u_02', userEmail: 'anna.m@payments.local', action: 'product.short_url_regenerated', entity: 'product', entityId: 'p_02', createdAt: ago(60 * 2) },
    { id: 'a6', userId: 'u_01', userEmail: 'pavel@payments.local', action: 'auth.login', entity: 'session', entityId: null, createdAt: ago(35) },
    { id: 'a7', userId: 'u_02', userEmail: 'anna.m@payments.local', action: 'auth.login', entity: 'session', entityId: null, createdAt: ago(320) },
  ] as MockAudit[],
};
